import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import plugins from "@/plugins";
import { i18n } from "@/translations";

// baseURL
window.baseURL = process.env.VUE_APP_baseURL;
window.appID = "AQISEo7L0wMh3";
window.domainURL = process.env.VUE_APP_domain;
Vue.config.productionTip = false;
if (!localStorage.getItem("locale")) {
  localStorage.setItem("locale", "en");
}

new Vue({
  i18n,
  plugins,
  router,
  render: (h) => h(App),
}).$mount("#app");
